module.exports = __webpack_public_path__ + "static/media/logo-shopify.eec50fac.svg";